/**
 * Assets: uvt-hero.js
 * -----------------------------------------------------------------------------
 * Pushes a dataLayer event when the uvt-hero CTA is clicked.
 * Uses one delegated listener so it also works for sections added in the
 * theme editor.
 *
 */
(() => {
  if (window.uvtHeroTracking) {
    return;
  }

  window.uvtHeroTracking = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.uvt-hero__cta');

    if (!link) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'water2_filter_jug_comparison_cta_click',
      placement: link.dataset.placement || 'unknown',
    });
  });
})();
